// Fetch settings
function getSettings(subscriberId) {
  return fetch(process.env.REACT_APP_CHAT_SERVER + "/api/Subscribers/" + subscriberId + "/settings").then(function (res) {
    return res.json();
  });
}
function addStyle(styleString) {
  var style = document.createElement("style");
  style.textContent = styleString;
  document.head.append(style);
}
export { getSettings, addStyle };